// modules
import 'bootstrap';
import setupSlideshows from './modules/slideshow';
import setupModalForms from './modules/modal-form';
import setupScrollToTop from './modules/scroll-to-top';
import displayUnderWritingQueue from './modules/underwriting-queue';


/**
 *
 */
window.addEventListener( 'DOMContentLoaded', () =>
{
	const body = document.querySelector( 'body' );

	if (body instanceof Element) {
		body.classList.add( 'loaded' );
	}

	setupSlideshows();
	setupModalForms();
	setupScrollToTop();
	displayUnderWritingQueue();
} );